<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="">
        <!-- Konto -->
        <!-- {{_imaAna}} -->
        <div class="row">
                <div class="col-md-4 col-4">
                    <div class="form-group row">
                        <div class="col-md-12">
                            <yt-dropdown-picklist 
                                [ModelName]="'orgjed'"
                                [GetName]="'getParentAndChildByParentID'"
                                [ModelProperty]="'Naziv'"
                                [OrderBy]="'Naziv'"
                                formControlName="OrgJedID"
                                #autofocus
                                [Label]="'FINDOKUMENTSTAVKA.ORGJED.SINGULAR'"  
                                [ngClass]="{'is-invalid': submitted && fc.OrgJedID.invalid}">
                            </yt-dropdown-picklist>
                            <div class="form-error" *ngIf="submitted && fc.OrgJedID.invalid">
                                <span *ngFor="let validation of errorMessages.OrgJedID">
                                <span class="error-message" *ngIf="fc.OrgJedID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                                </span>
                            </div>                              
                        </div>
                    </div>
                </div>
            <div class="col-md-4 col-4">
                <div class="form-group row">
                    <div class="col-md-12">
                            <yt-dropdown-picklist
                            [ModelName]="'kontniplan'"
                            [GetName]="'get'"
                            [ModelProperty]="'Konto,Naziv'"
                            [OrderBy]="'Naziv'"
                            [AllowAddNew]="true"
                            formControlName="KontoID"
                            [Label]="'FINDOKUMENTSTAVKA.KONTO.SINGULAR'"
                            (OnItemSelected)="onKontoSelected($event)"
                            >
                          </yt-dropdown-picklist>
                          <div class="form-error" *ngIf="submitted && fc.KontoID.invalid">
                            <span *ngFor="let validation of errorMessages.KontoID">
                            <span class="error-message" *ngIf="fc.KontoID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                            </span>
                        </div>     
                    </div>        
                </div>
            </div>
        </div>
        <!-- Kraj konto -->

        <!-- Komitent, brfak, datfak, datdpo -->
        <div class="row">
            <div class="col-md-12 col-6">
                <div class="form-group row">
                    <div class="col-md-4 col-12">
                        <div class="form-group row">
                            <div class="col-md-12">
                                <yt-dropdown-picklist
                                    [ModelName]="'komitent'"
                                    [GetName]="'get'"
                                    [ModelProperty]="'SNaziv, Mesto'"
                                    [OrderBy]="'SNaziv'"
                                    [AllowAddNew]="true"
                                    formControlName="KomitentID"
                                    [Label]="'FINDOKUMENTSTAVKA.KOMITENT.SINGULAR'"
                                    [Width]="'150%'"
                                    [Position]="'left'"                                    
                                    >
                                </yt-dropdown-picklist>
                                <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
                                    <span *ngFor="let validation of errorMessages.KomitentID">
                                        <span class="error-message" *ngIf="fc.KomitentID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                                    </span>
                                </div>
                            </div>
                        </div>      
                    </div> 
                    <div class="col-md-4 col-12">
                        <div class="form-group row">
                            <div class="col-md-12">
                                <yt-input
                                [Type]="'text'"
                                [Label]="'FINDOKUMENTSTAVKA.BRFAK.SINGULAR'"
                                formControlName="Brfak"></yt-input>
                                <div class="form-error" *ngIf="submitted && fc.Brfak.invalid">
                                    <span *ngFor="let validation of errorMessages.Brfak">
                                        <span class="error-message" *ngIf="fc.Brfak.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                                    </span>
                                </div>
                            </div>  
                        </div>  
                    </div>  
                    <div class="col-md-2">
                        <div class="form-group row">
                            <div class="col-md-12 col-6">
                                <yt-fw-date-picker-popup
                                formControlName="Datfak"
                                name="txtDatfak" 
                                [Label]="'FINDOKUMENTSTAVKA.DATFAK.SINGULAR'"
                                >
                                </yt-fw-date-picker-popup>
                                <div class="form-error" *ngIf="submitted && fc.Datfak.invalid">
                                    <span *ngFor="let validation of errorMessages.Datfak">
                                        <span class="error-message" *ngIf="fc.Datfak.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                                    </span>
                                </div>
                            </div> 
                        </div>
                    </div> 
                    <div class="col-md-2">
                        <div class="form-group row">
                            <div class="col-md-12 col-6">
                                <yt-fw-date-picker-popup
                                    formControlName="Datdpo"
                                    name="txtDatdpo" 
                                    [Label]="'FINDOKUMENTSTAVKA.DATDPO.SINGULAR'"
                                    >
                                </yt-fw-date-picker-popup>
                                <div class="form-error" *ngIf="submitted && fc.Datdpo.invalid">
                                    <span *ngFor="let validation of errorMessages.Datdpo">
                                        <span class="error-message" *ngIf="fc.Datdpo.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                                    </span>
                                </div>
                            </div>
                        </div> 
                    </div>
            </div>
        </div>        
    </div>
        <!-- Kraj komitent, brfak, datfak, datpdo -->

        <!-- Opis -->
        <div class="row">
            <div class="col-md-8 col-12">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input 
                            [Type]="'text'" 
                            [MaxLength]="60"
                            name="txtOpis"
                            formControlName="Opis"
                            [Label]="'FINDOKUMENTSTAVKA.OPIS.SINGULAR'">
                        </yt-input >
                    </div>        
                 </div>
            </div>
             <!-- Duguje, Potrazuje -->
            <div class="col-md-2 col-6">
                    <div class="form-group row">
                        <div class="col-md-12">
                            <yt-number-input-v3
                                name="txtDuguje"
                                formControlName="Duguje"
                                [Label]="'FINDOKUMENTSTAVKA.DUGUJE.SINGULAR'">
                            </yt-number-input-v3>
                            <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                                <span class="error-message" *ngIf="!this.baseFormGroup.errors.checkAmounts.valid"><span translate="{{this.baseFormGroup.errors.checkAmounts.message}}"></span></span>
                            </div>
                        </div>        
                    </div>
                </div> 
                <div class="col-md-2 col-6">
                    <div class="form-group row">
                        <div class="col-md-12">
                            <yt-number-input-v3
                                name="txtPotrazuje"
                                formControlName="Potrazuje"
                                [Label]="'FINDOKUMENTSTAVKA.POTRAZUJE.SINGULAR'">
                            </yt-number-input-v3>
                            <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                                <span class="error-message" *ngIf="!this.baseFormGroup.errors.checkAmounts.valid"><span translate="{{this.baseFormGroup.errors.checkAmounts.message}}"></span></span>
                            </div>
                        </div>        
                    </div>
                </div>
        </div>    
        <!-- Kraj Opis -->

        <!-- Duguje, Potrazuje -->
        <!-- <div class="row">
            <div class="col-md-4 col-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtDuguje"
                            formControlName="Duguje"
                            [Label]="'FINDOKUMENTSTAVKA.DUGUJE.SINGULAR'">
                        </yt-number-input-v3>
                    </div>        
                </div>
            </div> 
            <div class="col-md-4 col-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtPotrazuje"
                            formControlName="Potrazuje"
                            [Label]="'FINDOKUMENTSTAVKA.POTRAZUJE.SINGULAR'">
                        </yt-number-input-v3>
                    </div>        
                </div>
            </div>
        </div> -->
        <!-- Kraj Duguje, Potrazuje -->

         <!-- Devizno Duguje, Potrazuje, Valuta -->
         <div class="row">
                <div class="col-md-8 col-12">
                    <div class="form-group row">
                        <div class="col-md-12">
                            <yt-dropdown-picklist
                                [ModelName]="'valuta'"
                                [GetName]="'get'"
                                [ModelProperty]="'Naziv,Sifra,Sifra2'"
                                formControlName="ValutaID"
                                [AllowAddNew]="false"
                                [OrderBy]="'Naziv'"
                                [Label]="'FINDOKUMENTSTAVKA.VALUTA.SINGULAR'"
                                (OnItemSelected)="onDeviznoChange()">
                            </yt-dropdown-picklist>
                            <div class="form-error" *ngIf="submitted && fc.ValutaID.invalid">
                                <span *ngFor="let validation of errorMessages.ValutaID">
                                    <span class="error-message" *ngIf="fc.ValutaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            <div class="col-md-2 col-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtDDuguje"
                            formControlName="DDuguje"
                            [Label]="'FINDOKUMENTSTAVKA.DDUGUJE.SINGULAR'"
                            (OnBlur)="onDeviznoChange()">
                        </yt-number-input-v3>
                        <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                            <span class="error-message" *ngIf="!this.baseFormGroup.errors.checkAmounts.valid"><span translate="{{this.baseFormGroup.errors.checkAmounts.message}}"></span></span>
                        </div>
                    </div>        
                </div>
            </div> 
            <div class="col-md-2 col-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtDPotrazuje"
                            formControlName="DPotrazuje"
                            [Label]="'FINDOKUMENTSTAVKA.DPOTRAZUJE.SINGULAR'"
                            (OnBlur)="onDeviznoChange()">
                        </yt-number-input-v3>
                        <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                            <span class="error-message" *ngIf="!this.baseFormGroup.errors.checkAmounts.valid"><span translate="{{this.baseFormGroup.errors.checkAmounts.message}}"></span></span>
                        </div>
                    </div>        
                </div>
            </div>
            <!-- <div class="col-md-4 col-12">
                <div class="form-group row">
                    <div class="col-md-12">
                            <yt-dropdown-picklist
                            [ModelName]="'valuta'" 
                            [GetName]="'get'" 
                            [ModelProperty]="'Naziv,Sifra,Sifra2'"
                            formControlName="ValutaID" 
                            [AllowAddNew]="true"
                            [OrderBy]="'Naziv'"
                            [Label]="'FINDOKUMENTSTAVKA.VALUTA.SINGULAR'"
                            (OnItemSelected)="onDeviznoChange()"
                            >
                          </yt-dropdown-picklist>
                            <div class="form-error" *ngIf="submitted && fc.ValutaID.invalid">
                                <span *ngFor="let validation of errorMessages.ValutaID">
                                    <span class="error-message" *ngIf="fc.ValutaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                                </span>
                            </div>
                    </div>        
                </div>
            </div> -->
        </div>
        <!-- Kraj Devizno Duguje, Potrazuje, Valuta -->
    </form>
</div>